import { buildSchema, buildProperty, ExportMappingFunction } from "@camberi/firecms";

/**
 * This is a schema that is generated without passing an explicit type,
 * but it is inferred correctly since we are using `buildProperty` in each property
 */
export const videoSchema = buildSchema({
    name: "Video",
    properties: {
        videoName: buildProperty({
            title: "Video Name",
            validation: { required: true },
            dataType: "string"
        }),

        thumbnail: buildProperty({
            title: "Thumbnail Image",
            dataType: "reference",
            path: "media",
            previewProperties: ["mediaUrl"],
            validation: { required: true },
        }),
        timer: {
            title: "Timer (in seconds)",
            dataType: "number",
            validation: { required: true },
        },
        order: {
            title: "Order",
            dataType: "number",
            validation: { required: true },
        },
        categories: buildProperty({
            type: "Object",
            title: "video Category",
            dataType: "array",
            of: {
                dataType: "reference",
                path: "video_categories",
                previewProperties: ["categoryName", "thumbnailUrl"]
            }
        }),
      
        description: buildProperty({
            title: "Description",
            dataType: "string"
        }),
        videoUrl: buildProperty({
            title: "Video URL",
            dataType: "string",
            config: {
                storageMeta: {
                    mediaType: "video",
                    storagePath: `videos/${new Date().toLocaleDateString('en-CA')}/${new Date().getTime()}`,
                    acceptedFiles: ["video/*"],
                    storeUrl: true,
                    metadata: {
                        cacheControl: "max-age=1000000"
                    },
                    fileName: (context) => {
                        return Math.random()  + "-" + context.file.name;
                    }
                }
            },
            validation: { required: true },
        }),
        tags: buildProperty({
            title: "Tags",
            description: "Example of generic array",
            validation: { required: true },
            dataType: "array",
            of: {
                dataType: "string",
                // validation: { required: true },
                config: {
                    previewAsTag: true
                }
            }
        }),
        isFree: buildProperty({
            title: "isFree",
            dataType: "boolean"
        }),
        publishDate: buildProperty({
            title: "Publish date",
            dataType: "timestamp",
            validation: { required: true },
        }),
        status: buildProperty({
            title: "Status",
            validation: { required: true },
            dataType: "string",
            columnWidth: 140,
            config: {
                enumValues: {
                    published: "Published",
                    draft: "Draft"
                }
            }
        }),
        createdAt: {
            title: "createdAt",
            dataType: "timestamp",
            validation: { required: true },
        },
    },
    defaultValues: {
        status: "draft",
    }
});

/**
 * Sample field that will be added to the export
 */
export const sampleAdditionalExportColumn: ExportMappingFunction = {
    key: "extra",
    builder: async ({ entity }) => {
        await new Promise(resolve => setTimeout(resolve, 100));
        return "Additional exported value " + entity.id;
    }
};
